<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 个人中心 -->
        <div class="personal row">
            <div class="personal_l column">
                <div class="personal_l_info row" v-if="resumeFileList.length > 0">
                    <!-- <img src="@/assets/images/gerenzhongxinyonghuxinxi.png" alt="" style="width: 100%;"> -->
                    <div class="personal_l_info_l row">
                        <div class="personal_l_info_l_l">
                            <img v-if="yonghuxinxi" :src="yonghuxinxi.avatarUrl" class="personal_l_info_l_l_img">
                            <img v-else src="@/assets/images/resumeheader.jpg" class="personal_l_info_l_l_img">
                        </div>
                        <div class="personal_l_info_l_r column">
                            <div class="personal_l_info_l_r_name" v-if="zaixianjianli.name">{{ zaixianjianli.name }}</div>
                            <div class="personal_l_info_l_r_xinxi row">
                                <div v-if="zaixianjianli.age">{{ zaixianjianli.age }}岁</div>
                                <span v-if="zaixianjianli.workYear">|</span>
                                <div v-if="zaixianjianli.workYear">{{ zaixianjianli.workYear }}年经验</div>
                                <span v-if="zaixianjianli.educationName">|</span>
                                <div v-if="zaixianjianli.educationName">{{ zaixianjianli.educationName }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="personal_l_info_r column">
                        <div class="personal_l_info_r_top row">
                            <div class="personal_l_info_r_top_qiwang">期望：{{ zaixianjianli.expectJob
                                ? zaixianjianli.expectJob : '暂无' }}</div>
                            <div class="personal_l_info_r_top_xinzi" v-if="zaixianjianli.expectSalary">
                                {{ zaixianjianli.expectSalary }}K
                            </div>
                        </div>
                        <div class="personal_l_info_r_school row" v-if="zaixianjianli.eduList[0]">
                            <div class="personal_l_info_r_school_l">
                                {{ zaixianjianli.eduList[0].school }}
                            </div>
                            <div class="personal_l_info_r_school_r"
                                v-if="zaixianjianli.eduList[0].startDate && zaixianjianli.eduList[0].endDate">
                                {{ zaixianjianli.eduList[0].startDate }}-{{ zaixianjianli.eduList[0].endDate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="personal_l_info2 row" v-else>
                    暂无简历信息，请上传简历
                </div>

                <div class="personal_tabs">
                    <div class="personal_tabs_list row">
                        <!-- <img src="@/assets/images/gerentoutongxuanze.png" alt="" style="width: 100%;"> -->
                        <div :class="state == 1 ? 'personal_tabs_list_m2' : 'personal_tabs_list_m'" @click="clickTabs(1)">
                            已投递<span>{{ stcCntList.deliveryCnt }}</span></div>
                        <div :class="state == 2 ? 'personal_tabs_list_m2' : 'personal_tabs_list_m'" @click="clickTabs(2)">
                            面试<span>{{ stcCntList.interviewCnt }}</span></div>
                        <div :class="state == 3 ? 'personal_tabs_list_m2' : 'personal_tabs_list_m'" @click="clickTabs(3)">
                            感兴趣<span>{{ stcCntList.likeCnt }}</span></div>
                    </div>
                </div>
                <div class="personal_list" v-if="jobList.length > 0">
                    <div class="personal_list_m column" v-for="(item, index) in jobList" :key="index"
                        @click="goToJonDetails(index)">
                        <!-- <img src="@/assets/images/gerentoutongliebiao.png" alt="" style="width: 100%;"> -->
                        <div class="personal_list_m_top row">
                            <div class="personal_list_m_top_l row">
                                <img src="@/assets/images/resumeheader.jpg" class="personal_list_m_top_l_img">
                                <div class="personal_list_m_top_l_name">{{ item.publisherName }}</div>
                                <div class="personal_list_m_top_l_zhineng">{{ item.publisherPosition }}</div>
                            </div>
                            <div class="personal_list_m_top_r">
                                <div class="personal_list_m_top_r_goutong">继续沟通</div>
                            </div>
                        </div>
                        <div class="personal_list_m_main row">
                            <div class="personal_list_m_main_l column">
                                <div class="personal_list_m_main_l_top row">
                                    <div class="personal_list_m_main_l_top_l">{{ item.name }}</div>
                                    <div class="personal_list_m_main_l_top_r" v-if="item.workCities">
                                        [
                                        <div class="personal_list_m_main_l_top_r_m">
                                            {{ item.workCities }}
                                        </div>
                                        ]
                                    </div>
                                </div>
                                <div class="personal_list_m_main_l_bottom row">
                                    <div class="personal_list_m_main_l_bottom_xinzi">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}K·{{ item.salaryCnt }}薪
                                    </div>
                                    <div class="personal_list_m_main_l_bottom_tabs">
                                        <span v-if="item.workYear">{{ item.workYear }}年</span>
                                        <span>{{ item.education }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="personal_list_m_main_r row">
                                <img src="@/assets/images/qiyelogo2.jpg" class="personal_list_m_main_r_img">
                                <div class="personal_list_m_main_r_r column">
                                    <div class="personal_list_m_main_r_r_title" :title="item.companyName">
                                        {{ item.companyName }}
                                    </div>
                                    <div class="personal_list_m_main_r_r_tabs row">
                                        <!-- <span>不需要融资</span> -->
                                        <span v-if="item.companyTypeText">{{ item.companyTypeText }}</span>
                                        <span v-if="item.companyScaleText">{{ item.companyScaleText }}人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="personal_list_fenye" v-if="jobList.length > 0">
                    <el-pagination background layout="prev, pager, next" :total="total"></el-pagination>
                </div>
                <div class="personal_list" v-else>
                    <div class="zanwugengduozhiwei">暂无更多职位</div>
                </div>
            </div>
            <div class="personal_r column">
                <div class="personal_r_jianli column">
                    <!-- <img src="@/assets/images/gerenjianli.png" alt="" style="width: 100%;"> -->
                    <div class="personal_r_jianli_top row">
                        <div class="personal_r_jianli_top_title">附件管理</div>
                        <el-upload class="upload-demo" action="https://p.lietousaas.com/saas/zysp/resume/file"
                            :disabled="resumeFileList.length > 2" :data="uploadData" :headers="headers"
                            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                            <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    <div class="personal_r_jianli_main column" v-loading="fileLoading">
                        <div class="personal_r_jianli_main_text">文件（{{ resumeFileList.length }}/3）</div>
                        <div class="personal_r_jianli_main_file row" v-for="(item, index) in resumeFileList" :key="index">
                            <img v-if="item.fileType == 'doc'" src="@/assets/images/icon-doc.png"
                                class="personal_r_jianli_main_file_img">
                            <img v-if="item.fileType == 'pdf'" src="@/assets/images/icon-pdf.png"
                                class="personal_r_jianli_main_file_img">
                            <div class="personal_r_jianli_main_file_r column">
                                <div class="personal_r_jianli_main_file_title">{{ item.fileName }}</div>
                                <div class="personal_r_jianli_main_file_xiangqing">
                                    {{ item.fileSize * 1024 }}KB 更新于{{ item.createTime.split('T')[0] }}
                                </div>
                            </div>
                            <div class="personal_r_jianli_main_file_more column">
                                <div class="personal_r_jianli_main_file_more_dian">...</div>
                                <div class="personal_r_jianli_main_file_more_list column">
                                    <div class="personal_r_jianli_main_file_more_list_m" @click="shezhijianli(item)">
                                        设置为简历
                                    </div>
                                    <div class="personal_r_jianli_main_file_more_list_m" @click="xiazaijianli(item)">
                                        下载
                                    </div>
                                    <div class="personal_r_jianli_main_file_more_list_m" @click="chongmingmingjianli(item)">
                                        重命名</div>
                                    <div class="personal_r_jianli_main_file_more_list_m" @click="fileDel(item.id)">删除</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="personal_r_kangguowo">
                    <img src="@/assets/images/gerensheikanguowo.png" alt="" style="width: 100%;">
                </div> -->
                <div class="personal_r_guanggao">
                    <img src="@/assets/images/guanggao1.png" alt="" style="width: 100%;">
                </div>
                <div class="personal_r_guanggao">
                    <img src="@/assets/images/guanggao2.png" alt="" style="width: 100%;">
                </div>
                <div class="personal_r_guanggao">
                    <img src="@/assets/images/guanggao3.jpg" alt="" style="width: 100%;">
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaRecommend',
    components: { NavTop, Footer },
    data() {
        return {
            total: 0,
            state: 1,
            zaixianjianli: {},
            headers: {
                'Authorization': localStorage.getItem('Authorization'),// 假设token是从Vuex或者本地存储获取
            },
            uploadData: {
                fileName: '个人简历名称',
                parse: 0,
            },
            resumeFileList: [],
            resumeFileList2: [],
            fileLoading: false,
            status: 1,
            jobList: [],
            stcCntList: [],
            yonghuxinxi: {},
        }
    },
    mounted() {

    },
    activated() {
        this.state = 1;
        // 简历列表
        this.getResumeFile();
        // 获取在线简历
        this.getResumeOnline();
        // 投递反馈
        this.getOrderList();
        // 获取相关职位数量
        this.getJobStcCnt();
    },
    methods: {
        // 获取相关职位数量
        async getJobStcCnt() {
            let res = await this.$API.getJobStcCntApi();
            console.log('获取相关职位数量-->', res);
            if (res.code == 0) {
                this.stcCntList = res.data;
            }
        },
        // 投递反馈
        async getOrderList() {
            try {
                this.jobList = [];
                let res = await this.$API.getOrderListApi({ status: this.status });
                console.log('投递反馈-->', res);
                if (res.code == 0) {
                    this.jobList = res.data.records;
                } else {
                    this.$message.error(res.message);
                }
            } catch (error) {
                this.$message.error(res.message);
            }
        },
        // 获取在线简历
        async getResumeOnline() {
            let res = await this.$API.getResumeOnlineApi();
            console.log('获取在线简历-->', res);
            if (res.code == 0) {
                if (res.data) {
                    this.zaixianjianli = res.data;
                }
            }
        },
        // 跳转职位详情
        goToJonDetails(id) {
            this.$router.push('/jobdetail/' + 1);
        },
        // 选择tabs标签
        clickTabs(val) {
            this.state = val;
            if (val == 1) {
                this.status = 1;
                // 投递反馈
                this.getOrderList();
            }
            if (val == 2) {
                this.status = 4;
                // 投递反馈
                this.getOrderList();
            }
            if (val == 3) {
                this.status = 1;
                this.getJobList();
            }
        },
        // 职位列表-感兴趣
        async getJobList() {
            try {
                this.jobList = [];
                let res = await this.$API.getJobListApi({ liked: 1 });
                console.log('职位列表-感兴趣-->', res);
                if (res.code == 0) {
                    this.jobList = res.data.records;
                    this.total = res.data.total;
                } else {
                    this.$message.error(res.message);
                }
            } catch (error) {
                this.$message.error(res.message);
            }
        },
        handleAvatarSuccess(res, file) {
            console.log('res, file-->', res, file);
            // this.info.avatarUrl = URL.createObjectURL(file.raw);
            if (res.code == 0) {
                this.$message.success('上传成功！');
                this.getResumeFile();
            }
        },
        beforeAvatarUpload(file) {
            console.log('file-->', file);
            this.uploadData.fileName = file.name;
            const isWord = file.type === 'application/msword';
            const isPDF = file.type === 'application/pdf';
            const isLt2M = (file.size / 1024 / 1024) < 20;
            if (!isWord && !isPDF) {
                this.$message.error('上传文件只能是 Word/PDF 格式！');
            }
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 20MB！');
            }
            return isLt2M;
        },
        // 简历列表
        async getResumeFile() {
            let res = await this.$API.getResumeFileApi();
            console.log('简历列表-->', res);
            if (res.code == 0) {
                this.resumeFileList = res.data;
            }
            if (res.data.length < 1) {
                this.uploadData.parse = 1;
            } else {
                this.uploadData.parse = 0;
            }
        },
        // 删除简历
        async fileDel(id) {
            let res = await this.$API.getResumeFileIdApi(id);
            console.log('删除简历-->', res);
            if (res.code == 0) {
                this.$message.success('删除成功！');
                this.getResumeFile();
            } else {
                this.$message.error(res.message);
            }
        },
        // 设置简历
        async shezhijianli(item) {
            this.fileLoading = true;
            try {
                let res = await this.$API.postResumeFileParseIdApi(item.id);
                console.log('设置简历-->', res);
                if (res.code == 0) {
                    // 获取在线简历
                    this.getResumeOnline();
                    this.$message.success('设置成功！');
                } else {
                    this.$message.error('设置失败！');
                }
                this.fileLoading = false;
            } catch (error) {
                // 获取在线简历
                this.getResumeOnline();
                this.fileLoading = false;
                this.$message.error('设置失败！');
            }
        },
        // 下载简历
        xiazaijianli(item) {
            console.log('下载简历-->', item);
            let link = document.createElement('a');
            link.href = item.fileUrl;
            link.setAttribute('download', item.fileName); // 文件名及扩展名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        // 重命名简历
        chongmingmingjianli(item) {
            console.log('重命名简历-->', item.fileName.lastIndexOf("."));
            console.log('重命名简历-->', item.fileName.substring(0, item.fileName.lastIndexOf(".")));

            this.$prompt('请输入你确定要修改的简历名称', '修改附件简历名称', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // inputPattern: /[^\a-zA-Z\u4E00-\u9FA5]/g,
                inputPattern: /^.{1,20}$/,
                inputErrorMessage: '只能输入1-20个字符',
                inputValue: item.fileName.substring(0, item.fileName.lastIndexOf(".")),
                closeOnClickModal: false,
            }).then(({ value }) => {
                if (value.length <= 10) {
                    let name = String(value) + '.' + item.fileType
                    this.postResumeFileName(name, item.id)
                } else {
                    this.$message.error('修改失败！');
                }
            }).catch(() => {
                this.$message.error(res.message);
            });

        },
        // 调用重命名接口
        async postResumeFileName(filename, id) {
            this.fileLoading = true;
            try {
                let res = await this.$API.postResumeFileNameApi({ fileName: filename, id: id });
                console.log('调用重命名接口-->', res);
                if (res.code == 0) {
                    // 简历列表
                    this.getResumeFile();
                    this.$message.success('修改成功！');
                } else {
                    this.$message.error('修改失败！');
                }
                this.fileLoading = false;
            } catch (error) {
                this.$message.error('操作失败！');
                this.fileLoading = false;
            }
        }
    }

}
</script>

<style scoped>
.personal {
    width: 1200px;
    height: auto;
    margin: 20px auto;
    justify-content: space-between;
}

.personal_l {
    width: 900px;
    height: auto;
}

.personal_l_info {
    width: 860px;
    height: auto;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 12px;
}


.personal_l_info2 {
    width: 860px;
    height: auto;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 12px;
    color: #999;
    justify-content: center;
}

.personal_l_info_l {}

.personal_l_info_l_l {
    position: relative;
    height: 60px;
    width: 60px;
}

.personal_l_info_l_l_img {
    background-color: #f6f6f8;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.personal_l_info_l_r {
    margin-left: 20px;
    justify-content: space-evenly;
}

.personal_l_info_l_r_name {
    max-width: 160px;
    font-weight: 500;
    font-size: 20px;
    color: #222;
    height: auto;
    line-height: 24px;
}

.personal_l_info_l_r_xinxi {
    font-size: 14px;
    margin-top: 8px;
    color: #666;
}

.personal_l_info_l_r_xinxi>span {
    color: #e0e0e0;
    margin: 0 8px;
}

.personal_l_info_r {
    margin-left: 102px;
}

.personal_l_info_r_top {
    align-items: center;
}

.personal_l_info_r_top_qiwang {
    max-width: 280px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: 20px;
    line-height: 20px;
}

.personal_l_info_r_top_xinzi {
    margin: -1px 0 0 16px;
    font-size: 16px;
    font-weight: 500;
    color: #fe574a;
}

.personal_l_info_r_school {
    margin-top: 17px;
}

.personal_l_info_r_school_l {
    max-width: 280px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: 20px;
    line-height: 20px;
}

.personal_l_info_r_school_r {
    font-size: 14px;
    color: #999;
    font-weight: 400;
    height: 20px;
    line-height: 20px;
    margin-left: 20px;
}

.personal_tabs {
    width: calc(100% - 48px);
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 12px;
    padding: 0 24px;
}

.personal_tabs_list {
    height: 44px;
    line-height: 44px;
    margin: 0;
    padding: 0;
}

.personal_tabs_list_m {
    color: #333;
    font-weight: 500;
    margin-right: 36px;
    font-size: 15px;
    cursor: pointer;
    border-bottom: 2px solid #fff;
    align-items: center;
}

.personal_tabs_list_m>span {
    color: #b3b3b3;
    margin-left: 4px;
    margin-right: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
}

.personal_tabs_list_m2 {
    color: #00b277;
    font-weight: 500;
    margin-right: 36px;
    font-size: 15px;
    cursor: pointer;
    border-bottom: 2px solid #00b277;
    align-items: center;

}

.personal_tabs_list_m2>span {
    color: #00b277;
    margin-left: 4px;
    margin-right: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
}

.personal_list {
    width: 100%;
    height: auto;
}

.personal_list_m {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 12px;
    transition: all .2s linear;
}

.personal_list_m:hover {
    box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, .3);
}

.personal_list_m:hover .personal_list_m_top_r {
    display: block;
}

.personal_list_m_top {
    line-height: 24px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    justify-content: space-between;
    border-radius: 10px 10px 0 0;
}

.personal_list_m_top_l {
    padding: 12px 24px;
    line-height: 24px;
}

.personal_list_m_top_l_img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    border-radius: 50%;
}

.personal_list_m_top_l_name {
    color: #222;
    font-weight: 400;
    font-size: 13px;
}

.personal_list_m_top_l_zhineng {
    font-size: 13px;
    color: #666;
    font-weight: 400;
    margin-left: 12px;
}

.personal_list_m_top_r {
    display: none;
    margin-top: 8px;
    margin-right: 24px;
}

.personal_list_m_top_r_goutong {
    height: 32px;
    line-height: 30px;
    font-size: 13px;
    padding: 0 15px;
    border-radius: 8px;
    color: #fff;
    letter-spacing: 1px;
    background: #00b277;
    border-color: #00b277;
    border: 1px solid #00b277;
    margin-left: 15px;
    cursor: pointer;
}

.personal_list_m_top_r_goutong:hover {
    background: #00b277;
    border-color: #00b277;
}

.personal_list_m_main {
    padding: 16px 24px;
    justify-content: space-between;
    background: #fff;
    border-radius: 0 0 10px 10px;
}

.personal_list_m_main_l {}

.personal_list_m_main_l_top {
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    margin-bottom: 12px;
    cursor: pointer;
}

.personal_list_m_main_l_top:hover .personal_list_m_main_l_top_l {
    color: #00b277;
}

.personal_list_m_main_l_top_l {
    font-size: 16px;
    max-width: 255px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.personal_list_m_main_l_top_r {
    font-size: 16px;
    margin-left: 10px;
    color: #222;
    display: flex;
    align-items: center;
}

.personal_list_m_main_l_top_r_m {
    display: inline-block;
    font-style: normal;
    max-width: 165px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
}

.personal_list_m_main_l_bottom {
    height: 22px;
    line-height: 22px;
}

.personal_list_m_main_l_bottom_xinzi {
    font-size: 16px;
    font-weight: 500;
    color: #fe574a;
}

.personal_list_m_main_l_bottom_tabs {}

.personal_list_m_main_l_bottom_tabs>span {
    padding: 0 8px;
    display: inline-block;
    background: #f8f8f8;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    margin-right: 4px;
    margin-left: 8px;
}

.personal_list_m_main_r {
    width: 350px;
}

.personal_list_m_main_r_img {
    margin-top: 0;
    margin-left: 0;
    margin-right: 12px;
    width: 56px;
    height: 56px;
}

.personal_list_m_main_r_r {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 50px;

}

.personal_list_m_main_r_r_title {
    font-weight: 400;
    font-size: 16px;
    width: 230px;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.personal_list_m_main_r_r_tabs {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 22px;
    line-height: 22px;
}

.personal_list_m_main_r_r_tabs>span {
    padding: 0 8px;
    display: inline-block;
    background: #f8f8f8;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 400;
    color: #666;
    margin-right: 4px;
}


.personal_list_fenye {
    width: 100%;
    height: auto;
    margin: 10px auto 40px;
    text-align: center;
}

.personal_r {
    width: 280px;
    height: auto;
}

.personal_r_jianli {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
}

.personal_r_jianli_top {
    align-items: center;
    height: auto;
    padding: 12px 24px;
    line-height: 22px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 10px 10px 0 0;
    justify-content: space-between;
}

.personal_r_jianli_top_title {
    font-size: 16px;
    font-weight: 500;
    color: #222;
}

.personal_r_jianli_top>i {
    font-weight: bolder;
    cursor: pointer;
    color: #7c7e85;
    border: 1px solid;
    border-radius: 4px;
    padding: 2px;
}

.personal_r_jianli_top>i:hover {
    color: #00b277;
    border: 1px solid #00b277;
    border-radius: 4px;
    background: #fff;
    padding: 2px;
}

.personal_r_jianli_main {
    margin: 8px;
}

.personal_r_jianli_main_text {
    color: #333;
    font-size: 13px;
    font-weight: 500;
    padding: 8px 12px;
    line-height: normal;
}

.personal_r_jianli_main_file {
    color: #333;
    font-size: 14px;
    border-radius: 8px;
    transition: all .2s linear;
    padding: 8px 0px 8px 0px;
    cursor: pointer;
}

.personal_r_jianli_main_file:hover {
    background: #f7f7f7;
}

.personal_r_jianli_main_file_img {
    height: 44px;
    margin-right: 8px;
}

.personal_r_jianli_main_file_r {
    flex: 10;
}

.personal_r_jianli_main_file_title {
    line-height: 24px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
}

.personal_r_jianli_main_file_xiangqing {
    font-size: 12px;
    line-height: 17px;
    color: #8d92a1;
}

.personal_r_jianli_main_file_more {
    position: relative;
    justify-content: center;
}

.personal_r_jianli_main_file_more:hover .personal_r_jianli_main_file_more_list {
    display: block;
}

.personal_r_jianli_main_file_more:hover .personal_r_jianli_main_file_more_dian {
    color: #00b277;
}

.personal_r_jianli_main_file_more_dian {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    line-height: 17px;
    font-size: 20px;
    color: #a9adb7;
    font-weight: bold;
}

.personal_r_jianli_main_file_more_list {
    display: none;
    position: absolute;
    z-index: 110;
    top: 34px;
    right: 0;
    background: #fff;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .08);
    border-radius: 8px;
    border: 1px solid #ededed;
    padding: 4px;
}

.personal_r_jianli_main_file_more_list_m {
    align-items: center;
    border-radius: 4px;
    color: #222;
    font-weight: 400;
    line-height: 20px;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    transition: all .2s linear;
}

.personal_r_jianli_main_file_more_list_m:hover {
    color: #00b277;
    background: #f8f8f8;
}

.personal_r_kangguowo {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
}

.personal_r_guanggao {
    width: 100%;
    height: auto;
    /* background: #fff; */
    border-radius: 10px;
    margin-top: 20px;
}

.personal_r_guanggao img {
    border-radius: 10px;
}

.zanwugengduozhiwei {
    text-align: center;
    color: #999;
    font-size: 18px;
    padding-top: 20px;
}
</style>
